import {
  TERMS_AND_PRIVACY_CONSENT,
  COMMUNICATION_CONSENT,
  ConsentInput,
} from '@glass/common/modules/consent/types';
import removeEmptyKeys from '@glass/common/modules/utils/removeEmptyKeys';
import getBrowserLanguage from '@glass/web/modules/locales/getBrowserLanguage';
import getBrowserTimezone from '@glass/web/modules/locales/getBrowserTimezone';
import { CONSENTS_FIELD } from '@glass/web/modules/resumes/fieldKeys';

import {
  EMAIL_FIELD,
  PASSWORD_FIELD,
  COMMUNICATION_CONSENT_FIELD,
  TERMS_AND_PRIVACY_CONSENT_FIELD,
  PROFILE_FIELD,
} from '@glass/shared/modules/auth/userFields';

const consentFormToValues = ({
  [PASSWORD_FIELD]: password,
  [EMAIL_FIELD]: email,
  [COMMUNICATION_CONSENT_FIELD]: isCommunicationConsent,
  [TERMS_AND_PRIVACY_CONSENT_FIELD]: isTermsAndPrivacyConsent,
  [PROFILE_FIELD]: profile,
}: {
  [PASSWORD_FIELD]: string;
  [EMAIL_FIELD]: string;
  [COMMUNICATION_CONSENT_FIELD]: boolean;
  [TERMS_AND_PRIVACY_CONSENT_FIELD]: boolean;
  [PROFILE_FIELD]: Record<string, unknown>;
}) => {
  const consentAt = new Date();
  const consents: ConsentInput[] = [];

  if (isTermsAndPrivacyConsent) {
    consents.push({
      type: TERMS_AND_PRIVACY_CONSENT,
      consentAt,
    });
  }

  if (isCommunicationConsent) {
    consents.push({
      type: COMMUNICATION_CONSENT,
      consentAt,
    });
  }

  return removeEmptyKeys({
    [CONSENTS_FIELD]: consents,
    [EMAIL_FIELD]: email,
    [PASSWORD_FIELD]: password,
    [PROFILE_FIELD]: profile,
    browserLanguage: getBrowserLanguage(),
    browserTimezone: getBrowserTimezone(),
  });
};

export default consentFormToValues;
